import React, { forwardRef } from "react";

//package import

import { TextField, useTheme } from "@mui/material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

//component

export const CustomDateInput = forwardRef((props, ref) => {
  const { value, onChange, onClick, ...rest } = props;
  const theme = useTheme();

  return (
    <TextField
      value={value}
      onChange={onChange}
      onClick={onClick}
      ref={ref}
      {...rest}
      // sx={{
      //   border: "1px solid grey",
      //   borderRadius: theme.spacing(4),

      //   [`&.${formControlClasses?.root}`]: {
      //     border: "none",
      //   },
      //   [`& .${outlinedInputClasses?.root}`]: {
      //     backgroundColor: `${theme.palette.secondary.dark}`,
      //     borderRadius: theme.spacing(4),
      //   },
      // }}
      fullWidth
    ></TextField>
  );
});
